<template>
  <div class="auth">
    <component-layout :type="this.type" v-on:toggle-type="toggle"></component-layout>
  </div>
</template>

<script>
import componentLayout from './../components/auth/Layout.vue'

export default {
  name: 'auth',

  components: {
    componentLayout
  },

  beforeCreate() {
    if (localStorage.user) {
      this.$router.push({
        name: 'dash'
      })
    }
    else document.body.classList.remove('dash');
  },

  mounted() {
    let scriptCMP1 = document.createElement('script')
    scriptCMP1.setAttribute('src', 'https://cache.consentframework.com/js/pa/21964/c/lIACl/stub')
    document.head.appendChild(scriptCMP1)

    let scriptCMP2 = document.createElement('script')
    scriptCMP2.setAttribute('src', 'https://choices.consentframework.com/js/pa/21964/c/lIACl/cmp')
    scriptCMP2.setAttribute('async', 'true')
    document.head.appendChild(scriptCMP2)
  },

  data() {
    return {
      //type: 'signup'
      type: 'login'
    }
  },

  methods: {
    /**
     * Change type to display signup or login layout
     */
    toggle(type) {
      this.type = type
    }
  }
}
</script>
